import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionsService } from '../auth/permissions.service';

export const LoggedInGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
  return inject(PermissionsService).isLoggedIn$(next, state);
};
export const LoggedOutGuard: CanActivateFn = (): Observable<boolean> => {
  return inject(PermissionsService).isLoggedOut$();
};
export const FfdExpressGuard: CanActivateFn = (): Observable<boolean> => {
  return inject(PermissionsService).ffdExpressGuard$();
};
export const FfdCoreGuard: CanActivateFn = (): Observable<boolean> => {
  return inject(PermissionsService).ffdCoreGuard$();
};
